// The "Ready to publish" sign-off step is a per-mission flag that is only
// meaningful while the mission is still a draft. It is NOT a mission status:
// `Mission.status` stays DRAFT, the flag only changes how the mission is
// displayed. The rule lives here so every screen derives it the same way.

import { MISSION_STATUS_ENUM } from './constants'

export const MISSION_DISPLAY_STATUS_READY_TO_PUBLISH = 'READY_TO_PUBLISH'

/**
 * Whether a mission should be displayed as "Ready to publish"
 * @param {object} mission A mission with `status` and `isReadyToPublish`
 * @return {boolean}
 */
export const isMissionReadyToPublish = mission =>
  Boolean(mission) &&
  mission.status === MISSION_STATUS_ENUM.DRAFT &&
  mission.isReadyToPublish === true

/**
 * The status to display for a mission. Same as `mission.status` for everything
 * except drafts that have been signed off.
 * @param {object} mission A mission with `status` and `isReadyToPublish`
 * @return {string}
 */
export const getMissionDisplayStatus = mission =>
  isMissionReadyToPublish(mission)
    ? MISSION_DISPLAY_STATUS_READY_TO_PUBLISH
    : mission.status
